export class ActualFmpReportedTagExtension {
    _isAfterActualFmp(time) {
        if (this._actualFmp === undefined) {
            return false;
        }
        return time > this._actualFmp;
    }
    async preRegister(option) {
        option.slardar.on('beforeSend', (e) => {
            var _a;
            var _b;
            (_a = (_b = e.common).context) !== null && _a !== void 0 ? _a : (_b.context = {});
            if (this._actualFmp === undefined &&
                e.ev_type === 'performance' &&
                e.payload.isCustom === true &&
                e.payload.name === 'actual_fmp') {
                this._actualFmp = e.payload.value;
                return e;
            }
            if (e.ev_type === 'resource' && !('resources' in e.payload)) {
                e.common.context[ActualFmpReportedTagExtension._ACTUAL_FMP_CONTEXT_KEY] = String(this._isAfterActualFmp(e.payload.responseEnd));
                return e;
            }
            if (e.ev_type === 'http' && e.payload.response.timing) {
                e.common.context[ActualFmpReportedTagExtension._ACTUAL_FMP_CONTEXT_KEY] = String(this._isAfterActualFmp(e.payload.response.timing.responseEnd));
                return e;
            }
            if (e.ev_type === 'custom' && e.payload.name === 'jsb_event') {
                e.common.context[ActualFmpReportedTagExtension._ACTUAL_FMP_CONTEXT_KEY] = String(this._isAfterActualFmp(e.payload.metrics.responseEnd));
            }
            return e;
        });
    }
    async postRegister(_option) {
        return;
    }
}
ActualFmpReportedTagExtension._ACTUAL_FMP_CONTEXT_KEY = 'ttap_is_actual_fmp_reported';
//# sourceMappingURL=actualFmpReportedTag.js.map